$mol_view_tree2_to_js_test_ex_bidi_with_separate_default_in_right_part_foo $mol_object
	b? false
	a? <=> b?
